import { render, staticRenderFns } from "./my-uploadOnly.vue?vue&type=template&id=ad92a58c&scoped=true"
import script from "./my-uploadOnly.vue?vue&type=script&lang=js"
export * from "./my-uploadOnly.vue?vue&type=script&lang=js"
import style0 from "./my-uploadOnly.vue?vue&type=style&index=0&id=ad92a58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad92a58c",
  null
  
)

export default component.exports